// 1.iss code me ampersecond password me na leta tha 

// import React, { createContext, useEffect, useState } from 'react'
// import AxiosApi from '../api/AxiosApi';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';

// export const AuthenticationContext = createContext()
// export function AuthenticationProvider({ children }) {
//     const Navigate = useNavigate()
//     const [IsLogged, setIsLogged] = useState(false)
//     const [authLoading, setAuthLoading] = useState(true);
//     const [LoginLoading, setLoginLoading] = useState(false)
//     const [LoggedInUserInfo, setLoggedInUserInfo] = useState(null)
//     // LOGIN_NAME is LOGIN_ID
//     function userLogin(LOGIN_NAME,PW, APP_KEY) {
//         localStorage.setItem('LoginID', LOGIN_NAME)
//         localStorage.setItem('PW', PW)

//         // console.log("passwordAUTH",PW)

//         setLoginLoading(true)
//         let headersList = {
//             "Accept": "/",
//             "Content-Type": "application/x-www-form-urlencoded"
//         }
//         let bodyContent = `LOGIN_NAME=${LOGIN_NAME}&PW=${PW}&APP_KEY=${APP_KEY}`;
//         AxiosApi.post('login/LoginWEB', bodyContent, headersList)
//             .then((res) => {
//                 localStorage.setItem('LoggedInUserInfo', JSON.stringify(res?.data))
//                 localStorage.setItem('LCODE', res?.data?.Loc_Code)

//                 console.log("loccode", localStorage.setItem('LCODE', res?.data?.Loc_Code))

//                 setLoggedInUserInfo(res?.data)
//                 setLoginLoading(false)
//                 setIsLogged(true)
//                 const loginInfoData = localStorage.getItem("pass")
//                 if(loginInfoData !="target")
//                         Navigate("/userDashboard")

//             }).catch((er) => {
//                 alert('Invalid Credentials!')
//                 console.log('err', er)
//                 console.log("passwordAUTH",PW)
//                 setLoginLoading(false)
//             });

//     }

//     function logOut() {
//         localStorage.clear()
//         setLoggedInUserInfo(null)
//         setIsLogged(false)


//         // setTimeout(() => {

//         //     const loginInfoData = localStorage.getItem("pass")
//         //     if(loginInfoData !="target")

//         //     Navigate('/login', { replace: true });  // ✅ Ensure proper navigation
//         // }, 0);

//         Navigate('/login')


//         // const loginInfoData = localStorage.getItem("pass")
//         //         if(loginInfoData !="target")
//         //                 Navigate("/login")
//     }

//     useEffect(() => {
//         const data = localStorage.getItem('LoggedInUserInfo')
//         const userData = JSON.parse(data)
//         if (userData) {
//            setIsLogged(true)
//             setLoggedInUserInfo(userData)
//           //  Navigate('/userDashboard')
//         } else {
//             setIsLogged(false)
//             setLoggedInUserInfo(null)
//             localStorage.clear()
//            Navigate('login')
//         }

//         setAuthLoading(false);  // ✅ Done loading
//     }, [IsLogged])







//     return (
//         <AuthenticationContext.Provider value={{ IsLogged, setLoggedInUserInfo, LoggedInUserInfo, LoginLoading, userLogin, logOut,authLoading }}>
//             {children}
//         </AuthenticationContext.Provider>
//     )
// }


// 1.

import React, { createContext, useEffect, useState } from 'react'
import AxiosApi from '../api/AxiosApi';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export const AuthenticationContext = createContext()
export function AuthenticationProvider({ children }) {
    const Navigate = useNavigate()
    const [IsLogged, setIsLogged] = useState(false)
    const [authLoading, setAuthLoading] = useState(true);
    const [LoginLoading, setLoginLoading] = useState(false)
    const [LoggedInUserInfo, setLoggedInUserInfo] = useState(null)
    // LOGIN_NAME is LOGIN_ID
    function userLogin(LOGIN_NAME, PW, APP_KEY) {
        localStorage.setItem('LoginID', LOGIN_NAME)
        localStorage.setItem('PW', PW)

  // console.log("passwordAUTH",PW)

        setLoginLoading(true)
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        let bodyParams = new URLSearchParams();
        bodyParams.append('LOGIN_NAME', LOGIN_NAME);
        bodyParams.append('PW', PW);
        bodyParams.append('APP_KEY', APP_KEY);

        AxiosApi.post('login/LoginWEB', bodyParams,headersList)
       .then((res) => {
                localStorage.setItem('LoggedInUserInfo', JSON.stringify(res?.data))
                localStorage.setItem('LCODE', res?.data?.Loc_Code)

                 console.log("loccode",res?.data?.Loc_Code)

                setLoggedInUserInfo(res?.data)
                setLoginLoading(false)
                setIsLogged(true)
                const loginInfoData = localStorage.getItem("pass")
                if (loginInfoData != "target")
                    Navigate("/userDashboard")

            }).catch((er) => {
                alert('Invalid Credentials!')
                // console.log('err', er)
                // console.log("passwordAUTH", PW)
                setLoginLoading(false)
            });

    }

    function logOut() {
        localStorage.clear()
        setLoggedInUserInfo(null)
        setIsLogged(false)


        // setTimeout(() => {

        //     const loginInfoData = localStorage.getItem("pass")
        //     if(loginInfoData !="target")

        //     Navigate('/login', { replace: true });  // ✅ Ensure proper navigation
        // }, 0);

        Navigate('/login')


        // const loginInfoData = localStorage.getItem("pass")
        //         if(loginInfoData !="target")
        //                 Navigate("/login")
    }

    useEffect(() => {
        const data = localStorage.getItem('LoggedInUserInfo')
        const userData = JSON.parse(data)
        if (userData) {
            setIsLogged(true)
            setLoggedInUserInfo(userData)
            //  Navigate('/userDashboard')
        } else {
            setIsLogged(false)
            setLoggedInUserInfo(null)
            localStorage.clear()
            Navigate('login')
        }

        setAuthLoading(false);  // ✅ Done loading
    }, [IsLogged])




    return (
        <AuthenticationContext.Provider value={{ IsLogged, setLoggedInUserInfo, LoggedInUserInfo, LoginLoading, userLogin, logOut, authLoading }}>
            {children}
        </AuthenticationContext.Provider>
    )
}
